import { z } from 'zod';

export const SignatureTaskSchema = z.object({
  signature: z.string().min(1, 'Signature is required'),
});
